module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_1_2-79fb852624694d145190c59a29697013.png";